import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GeneralResponse } from 'app/models/general-response.model';
import { User } from 'app/models/user.model';
import { environment } from 'environments/environment';
import { catchError, Observable, of, ReplaySubject, tap } from 'rxjs';
import { SitesMap } from '../sites/site.service';

@Injectable({
    providedIn: 'root',
})
export class UserService {
    /**
     * Objects
     */
    private _user: ReplaySubject<User> = new ReplaySubject<User>(1);
    // private _userSite: SitesMap[];
    private _userFTSite: ReplaySubject<string[]> = new ReplaySubject<string[]>(
        1
    );
    private _userSite: ReplaySubject<SitesMap[]> = new ReplaySubject<
        SitesMap[]
    >(1);
    // private loggedUserSiteList: string[] = [];
    private _loggedUserSiteList: string[] = [];
    private _userMappingSiteList: string[] = [];

    //variable to check whether user has logged off and on
    private _userName: string;
    private _signOut: boolean;

    /**
     * Constructor
     * @param _httpClient
     */
    constructor(private _httpClient: HttpClient) {
        // console.log('[Users Service] constructor')
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for user
     *
     * @param value
     */
    set user(value: User) {
        // Store the value
        this._user.next(value);
    }

    get user$(): Observable<User> {
        return this._user.asObservable();
    }

    /**
     * Getter for user sites list
     *
     * @param value
     */

    get userSite$(): Observable<SitesMap[]> {
        return this._userSite.asObservable();
    }

    // get userFTSite$(): Observable<string[]> {
    //     return this._userFTSite.asObservable();
    // }

    /**
     * Setter & getter for user site List
     *
     * @param list[]
     */

    /**
     * Setter & getter for user name
     *
     * @param value
     */
    set userName(value: string) {
        // Store the value
        this._userName = value;
    }

    get userName() {
        return this._userName;
    }

    /**
     * Setter & getter for signOut
     *
     * @param value
     */
    set signOut(value: boolean) {
        // Store the value
        this._signOut = value;
    }

    get signOut() {
        return this._signOut;
    }

    //get user sites(not Physical location)
    get loggedUserSiteList() {
        return this._loggedUserSiteList;
    }

    set loggedUserSiteList(lst: string[]) {
        this._loggedUserSiteList = lst;
    }

    get userMappingSiteList() {
        return this._userMappingSiteList;
    }

    set userMappingSiteList(lst: string[]) {
        this._userMappingSiteList = lst;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get the current logged in user data
     */
    get(): Observable<GeneralResponse> {
        // console.log('[User Service] get')
        let authParams = new HttpParams().set(
            'user_name',
            localStorage.getItem('fishTrackUserName')
        ); //Create new HttpParams

        return this._httpClient
            .get<GeneralResponse>(
                `${environment.backendURL}${environment.userURL}`,
                { params: authParams }
            )
            .pipe(
                tap((user: GeneralResponse) => {
                    this._user.next(user.workload);
                    // this._userSite.next(user.workload.sites.split(','));
                    this._userSite.next(user.workload.sites);
                    // this._userFTSite.next(user.workload.sites.map(site=>site.cfms_code))
                    this.loggedUserSiteList =
                        user.workload.sites_delimited.split(',');
                    this.userMappingSiteList = user.workload.sites;
                }),
                catchError((err) => {
                    let customResponse = {
                        code: err.status,
                        msg: 'Could not load data',
                    } as GeneralResponse;
                    return of(customResponse);
                })
            );
    }
}
